/* Electric Wheels — product page (brief §6.1, §6.7, Part 7)
   Gallery, fitment confirmation, finish + pack selection, express-checkout
   adaptation and the sticky bar. Vanilla, no dependencies. */
(function () {
  var root = document.querySelector('[data-ew-pdp]');
  if (!root) return;

  var $  = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  var F = window.EWFitment;
  var FITS = (root.getAttribute('data-fits') || '').split(' ').filter(Boolean);
  /* add-on with no covers in the cart: buying stays off (see the section) */
  var BLOCKED = root.getAttribute('data-blocked') === '1';
  var FMT = root.getAttribute('data-money-format') || '£{{amount}}';
  /* delivery speed, from Theme settings → Electric Wheels */
  var SPEED = root.getAttribute('data-speed') || '';

  function money(cents) {
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    n = parts.join('.');
    return FMT.indexOf('{{') > -1 ? FMT.replace(/\{\{\s*amount[^}]*\}\}/, n) : '£' + n;
  }

  /* ------------------------------------------------------------- gallery
     The main viewer is a scroll-snap track: swiping, the arrows and the
     thumbnails all just scroll it, and the scroll position decides which
     thumbnail is active — so the three can never disagree. */
  var track  = $('[data-ew-track]');
  var shots  = $$('[data-ew-shot]');
  var thumbs = $$('[data-ew-thumb]');
  var cap    = $('[data-ew-cap]');
  var prevB  = $('[data-ew-prev]');
  var nextB  = $('[data-ew-next]');
  var capBase = cap ? cap.textContent.trim() : '';
  var curShot = -1;

  function goShot(i, instant) {
    if (!track || i < 0 || i >= shots.length) return;
    track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'instant' : 'smooth' });
  }

  function markShot(i) {
    if (i === curShot) return;
    curShot = i;
    thumbs.forEach(function (t, n) { t.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
    if (thumbs[i] && thumbs[i].parentNode.scrollWidth > thumbs[i].parentNode.clientWidth) {
      var row = thumbs[i].parentNode;
      row.scrollTo({ left: thumbs[i].offsetLeft - row.clientWidth / 2 + thumbs[i].clientWidth / 2, behavior: 'smooth' });
    }
    if (cap) {
      cap.textContent = (i === 0 && capBase ? capBase + ' · ' : '') + (i + 1) + '/' + shots.length;
      if (shots.length < 2) cap.textContent = capBase;
      cap.hidden = !cap.textContent;
    }
    if (prevB) prevB.disabled = i === 0;
    if (nextB) nextB.disabled = i === shots.length - 1;
    /* a video scrolled away keeps playing otherwise */
    shots.forEach(function (s, n) {
      if (n === i) return;
      var v = s.querySelector('video');
      if (v && !v.paused) v.pause();
    });
  }

  if (track) {
    var scrollRaf = 0;
    track.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = 0;
        markShot(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goShot(curShot + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goShot(curShot - 1); }
    });
    /* keep the same photo in view when the column resizes */
    window.addEventListener('resize', function () { goShot(curShot, true); });
    markShot(0);
  }
  /* a long jump would scroll past dozens of photos — go straight there */
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goShot(i, Math.abs(i - curShot) > 2); }); });
  if (prevB) prevB.addEventListener('click', function () { goShot(curShot - 1); });
  if (nextB) nextB.addEventListener('click', function () { goShot(curShot + 1); });

  /* -------------------------------------------------- full-screen viewer */
  var lb = $('[data-ew-lb]');
  if (lb && typeof lb.showModal === 'function') {
    var lbTrack = $('[data-ew-lb-track]', lb);
    var lbShots = $$('[data-ew-lb-shot]', lb);
    var lbN     = $('[data-ew-lb-n]', lb);
    var lbCur   = 0;

    var lbLoad = function (i) {
      [i - 1, i, i + 1].forEach(function (n) {
        var img = lbShots[n] && lbShots[n].querySelector('img[data-src]');
        if (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
      });
    };
    var lbGo = function (i, instant) {
      if (i < 0 || i >= lbShots.length) return;
      lbTrack.scrollTo({ left: i * lbTrack.clientWidth, behavior: instant ? 'instant' : 'smooth' });
    };
    var lbMark = function (i) {
      lbCur = i;
      lbLoad(i);
      if (lbN) lbN.textContent = (i + 1) + ' / ' + lbShots.length;
      lbShots.forEach(function (s, n) {
        if (n !== i) {
          s.classList.remove('is-zoomed');
          var v = s.querySelector('video');
          if (v && !v.paused) v.pause();
        }
      });
    };

    $$('[data-ew-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        var media = parseInt(b.getAttribute('data-ew-zoom'), 10);
        var idx = 0;
        lbShots.forEach(function (s, n) { if (parseInt(s.getAttribute('data-ew-lb-shot'), 10) === media) idx = n; });
        lb.showModal();
        document.documentElement.style.overflow = 'hidden';
        lbMark(idx);
        lbGo(idx, true);
      });
    });

    lbTrack.addEventListener('scroll', function () {
      var i = Math.round(lbTrack.scrollLeft / Math.max(1, lbTrack.clientWidth));
      if (i !== lbCur) lbMark(i);
    }, { passive: true });

    /* desktop: click toggles 100% size; phones pinch natively */
    lbShots.forEach(function (s) {
      s.addEventListener('click', function (e) {
        if (e.target.tagName !== 'IMG' || !window.matchMedia('(pointer: fine)').matches) return;
        var on = !s.classList.contains('is-zoomed');
        s.classList.toggle('is-zoomed', on);
        if (on) {
          var r = e.target.getBoundingClientRect();
          var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
          requestAnimationFrame(function () {
            s.scrollLeft = fx * s.scrollWidth - s.clientWidth / 2;
            s.scrollTop  = fy * s.scrollHeight - s.clientHeight / 2;
          });
        }
      });
    });

    /* the expand button opens the viewer on whatever the gallery shows,
       video included */
    var expand = $('[data-ew-expand]');
    if (expand) {
      expand.addEventListener('click', function () {
        var idx = 0;
        lbShots.forEach(function (s, n) { if (parseInt(s.getAttribute('data-ew-lb-shot'), 10) === Math.max(curShot, 0)) idx = n; });
        lb.showModal();
        document.documentElement.style.overflow = 'hidden';
        lbMark(idx);
        lbGo(idx, true);
      });
    }

    var lbClose = function () { if (lb.open) lb.close(); };
    lb.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      lb.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); });
      /* land the page viewer on whichever photo was last looked at */
      var media = lbShots[lbCur] && parseInt(lbShots[lbCur].getAttribute('data-ew-lb-shot'), 10);
      if (!isNaN(media)) goShot(media, true);
    });
    $('[data-ew-lb-close]', lb).addEventListener('click', lbClose);
    $('[data-ew-lb-prev]', lb).addEventListener('click', function () { lbGo(lbCur - 1); });
    $('[data-ew-lb-next]', lb).addEventListener('click', function () { lbGo(lbCur + 1); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') lbGo(lbCur + 1);
      if (e.key === 'ArrowLeft')  lbGo(lbCur - 1);
    });
  }

  /* -------------------------------------------------- §6.1.5 fitment panel */
  var res = $('[data-ew-fitres]');

  function fitCopy(id) {
    var info = F.info(id);
    /* no panel on non-cover products (the logo-caps add-on) */
    if (!info || !res) return;
    res.hidden = false;
    res.textContent = '';
    var h = document.createElement('p');
    h.className = 'ew-fitres__h';
    var b = document.createElement('p');
    b.className = 'ew-fitres__b';

    if (FITS.indexOf(id) > -1) {
      res.className = 'ew-fitres is-yes';
      h.textContent = 'Fits your ' + info.name;
      b.textContent = 'Made for the factory ' + info.wheel + ' ' + info.rim +
                      ' wheel — correct diameter and clip pattern. Order with confidence.';
      res.appendChild(h); res.appendChild(b);
    } else {
      res.className = 'ew-fitres is-no';
      h.textContent = 'This set is not for your ' + info.name;
      var names = FITS.map(function (f) { return F.info(f).name; });
      b.textContent = 'This design is made for ' +
        (names.length ? names.join(' and ') : 'a different generation') + '.';
      res.appendChild(h); res.appendChild(b);
      var a = document.createElement('a');
      a.href = '#related';
      a.textContent = 'See the designs that fit your car';
      var wrap = document.createElement('p');
      /* Its own class because this link is the whole paragraph, not a phrase
         inside one — on a phone it needs a 44px target of its own. */
      wrap.className = 'ew-fitres__b ew-fitres__cta';
      wrap.appendChild(a);
      res.appendChild(wrap);
    }
    /* §6.1.5 — never disable add-to-cart on a fitment guess we can't verify */
  }

  $$('[data-ew-fitpill]').forEach(function (b) {
    b.addEventListener('click', function () {
      var id = b.getAttribute('data-ew-fitpill');
      F.set(F.get() === id ? null : id);
    });
  });

  F.on(function (id) {
    $$('[data-ew-fitpill]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-ew-fitpill') === id ? 'true' : 'false');
    });
    if (id) fitCopy(id);
    else if (res) { res.hidden = true; }
  });

  /* the header chip scrolls back to the panel */
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-ew-chip]');
    var panel = $('[data-ew-fitpanel]');
    if (!c || !panel) return;
    panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* --------------------------------------------- finish + pack selection */
  var variantBtns = $$('[data-ew-variant]');
  var priceEl     = $('[data-ew-price]');
  var finishLbl   = $('[data-ew-finish-lbl]');
  var stickySub   = $('[data-ew-stickysub]');
  var stickyPrice = $('[data-ew-stickyprice]');

  /* seeded from the root, which always carries the selected variant — the
     variant buttons only exist when there is more than one */
  var cur = {
    id: ($('[data-ew-id]') || {}).value,
    price: parseInt(root.getAttribute('data-price'), 10) || 0,
    available: root.getAttribute('data-available') === '1',
    finish: finishLbl ? finishLbl.textContent.trim() : ''
  };
  variantBtns.forEach(function (b) {
    if (b.getAttribute('aria-checked') === 'true') {
      cur.price = parseInt(b.getAttribute('data-price'), 10);
      cur.available = b.getAttribute('data-available') === '1';
      cur.finish = b.querySelector('.ew-opt__t').textContent.trim();
    }
  });
  var buyErr = $('[data-ew-buyerr]');

  /* one set per add-to-cart — the "How many sets?" selector was removed;
     quantity is changed in the cart */
  function paint() {
    var total = cur.price;
    if (priceEl) priceEl.textContent = money(total);
    if (finishLbl) finishLbl.textContent = cur.finish;
    $$('[data-ew-id]').forEach(function (i) { i.value = cur.id; });
    /* a sold-out ?variant= deep link renders disabled; picking an in-stock
       option has to bring the button back */
    $$('[data-ew-atc]').forEach(function (b) {
      b.disabled = !cur.available || BLOCKED;
      b.textContent = BLOCKED ? 'Add a set of covers first' : (cur.available ? 'Add to cart' : 'Sold out');
    });
    if (buyErr) buyErr.hidden = true;
    if (stickyPrice) stickyPrice.textContent = money(total);
    if (stickySub) {
      /* wheel size only for covers — an empty data-fits used to read as 19″ */
      stickySub.textContent = FITS.length
        ? 'One set' + (cur.finish ? ' · ' + cur.finish + (root.getAttribute('data-finish-suffix') || '') : '') + ' · ' + (FITS[0].indexOf('m3') === 0 ? '18″' : '19″')
        : cur.finish;
    }
  }

  variantBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.hasAttribute('disabled')) return;
      variantBtns.forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
      cur.id = b.getAttribute('data-ew-variant');
      cur.price = parseInt(b.getAttribute('data-price'), 10);
      cur.available = b.getAttribute('data-available') === '1';
      cur.finish = b.querySelector('.ew-opt__t').textContent.trim();
      paint();
      /* show this option's own photo, and make the link shareable */
      var shot = b.getAttribute('data-shot');
      if (shot !== null && shot !== '') goShot(parseInt(shot, 10));
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', cur.id);
        history.replaceState(history.state, '', u.toString());
      }
    });
  });

  /* arriving on ?variant=…: open the gallery on that option's photo */
  if (/[?&]variant=/.test(window.location.search)) {
    variantBtns.forEach(function (b) {
      var shot = b.getAttribute('data-shot');
      if (b.getAttribute('aria-checked') === 'true' && shot) {
        requestAnimationFrame(function () { goShot(parseInt(shot, 10), true); });
      }
    });
  }

  paint();

  /* --------------------------------------------- Part 7 express checkout */
  var buy  = $('[data-ew-buy]');
  var note = $('[data-ew-buynote]');

  /* Shopify renders wallets as <shopify-accelerated-checkout> now (the
     wallet it chose is in its `recommended` JSON); older stores still get
     .shopify-payment-button__button. Either counts as an express button. */
  function expressEl() {
    return document.querySelector('.ew-buy__express shopify-accelerated-checkout, .ew-buy__express .shopify-payment-button__button');
  }

  function adaptExpress() {
    var btn = expressEl();
    var live = !!(btn && btn.offsetHeight);
    if (buy) buy.classList.toggle('has-express', live);
    if (!note) return;
    /* no wallet named: Shopify's `recommended` guess (Apple Pay on an iPhone
       UA) can differ from the button it finally draws (e.g. Shop Pay) */
    note.textContent = 'Ships from our own Bedfordshire stock' + (SPEED ? ' · ' + SPEED : '') +
      (live ? '' : ' · Apple Pay, PayPal or card');
  }

  adaptExpress();
  /* Shopify injects the wallet button asynchronously */
  var tries = 0;
  var poll = setInterval(function () {
    adaptExpress();
    if (++tries > 20) clearInterval(poll);
  }, 250);

  /* ---------------------------------------------------------- share */
  var share = $('[data-ew-share]');
  if (share) {
    share.addEventListener('click', function () {
      var url = share.getAttribute('data-url') + (cur.id ? '?variant=' + cur.id : '');
      var title = share.getAttribute('data-title');
      var label = share.querySelector('[data-ew-share-label]');
      var done = function (t) { label.textContent = t; setTimeout(function () { label.textContent = 'Share'; }, 2000); };
      /* older browsers / blocked clipboard: a hidden textarea + copy command */
      var legacyCopy = function () {
        var ta = document.createElement('textarea');
        ta.value = url; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) {}
        ta.remove();
        if (ok) done('Link copied'); else window.prompt('Copy this link', url);
      };
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(function () { done('Link copied'); }, legacyCopy);
      } else {
        legacyCopy();
      }
    });
  }

  /* ------------------------------------------------- §6.7 sticky bar */
  var sticky = $('[data-ew-sticky]');
  if (sticky) {
    var shown = false;
    /* only once the main buy box is off screen — two add-to-cart buttons
       on screen at once read as a glitch */
    var buyBox = $('[data-ew-buy]');
    var buyVisible = false;
    if (buyBox && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        buyVisible = es[0].isIntersecting;
        onScroll();
      }).observe(buyBox);
    }
    var onScroll = function () {
      var on = window.scrollY > 780 && !buyVisible;
      if (on === shown) return;
      shown = on;
      if (on) sticky.hidden = false;
      requestAnimationFrame(function () { sticky.classList.toggle('is-on', on); });
      document.body.classList.toggle('ew-has-sticky', on);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --------------------------------------------- add to cart → §6.8 drawer */
  $$('form.ew-buyform, form.ew-sticky__acts').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (!window.EWCart) return;               /* let it post normally */
      e.preventDefault();
      var btn = f.querySelector('[data-ew-atc]');
      var was = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      if (buyErr) buyErr.hidden = true;
      /* EWCart.add only rejects when /cart/add.js itself failed, so the
         fallback post can't add the item a second time */
      window.EWCart.add(cur.id, 1).then(function () {
        if (btn) { btn.disabled = false; btn.textContent = was; }
      }).catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = was; }
        if (err && err.description && buyErr) {
          buyErr.textContent = err.description;
          buyErr.hidden = false;
          buyErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          f.submit();
        }
      });
    });
  });
})();
